import { applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { history } from '../routes';
import APIMiddleware from '../infrastructure/api';
import nextActionMiddleware from './middleware/nextActionMiddleware';
import pushRouteMiddleware from './middleware/pushRouteMiddleware';
import redirectActionMiddleware from './middleware/redirectActionMiddleware';
import reduxThunk from 'redux-thunk';

/* eslint-disable no-underscore-dangle */
let composeEnhancers = compose;
if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}
/* eslint-enable */

export default composeEnhancers(
  applyMiddleware(
    ...APIMiddleware,
    nextActionMiddleware,
    pushRouteMiddleware,
    redirectActionMiddleware,
    routerMiddleware(history),
    reduxThunk
  )
);
